
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.863 7.044l-4.881 4.881-1.188 1.188a.248.248 0 01-.396 0L6.21 11.925 4.1 9.815a.248.248 0 010-.397L5.287 8.23a.248.248 0 01.396 0l1.98 1.98 4.75-4.75a.248.248 0 01.395 0l1.188 1.187a.485.485 0 01-.132.397zM9 .36c1.644 0 3.166.411 4.565 1.234a8.53 8.53 0 013.202 3.201A8.851 8.851 0 0118 9.36a8.851 8.851 0 01-1.233 4.565 8.53 8.53 0 01-3.202 3.202A8.851 8.851 0 019 18.36a8.851 8.851 0 01-4.565-1.233 8.691 8.691 0 01-3.202-3.223A8.812 8.812 0 010 9.36c0-1.63.411-3.144 1.233-4.543a8.858 8.858 0 013.224-3.223A8.812 8.812 0 019 .36z","fill":"#2CC692","fill-rule":"evenodd"}})])
          )
        }
      }
    